import React from 'react';

import connectToStores from 'alt-utils/lib/connectToStores';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';
import MatchedRulePopover from 'components/inbox/mail-toolbar/MatchedRulePopover';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import {List} from 'immutable';
import TriggerPermission from 'records/TriggerPermission';
import AuthStore from 'stores/AuthStore';

@connectToStores
export default class MatchedRulePopoverContainer extends React.Component {
  constructor(props) {
    super(props);
    this.loadData = this.loadData.bind(this);
    this.getRuleIds = this.getRuleIds.bind(this);
    this.toggleNotify = this.toggleNotify.bind(this);
  }

  static getStores() {
    return [AuthStore, TriggerRuleStore];
  }

  getRuleIds() {
    // if we've loaded with a rule rather than an inbox item, well,
    // we know exactly what to do. return it
    if (this.props.ruleId) {
      return List([this.props.ruleId]);
    }

    // Fetch all of the rule ids grouped with this file that are
    // from a smart alerts trigger
    if (
      !this.props ||
      !this.props.inboxItem ||
      this.props.inboxItem.context.type !== 'trigger_notification'
    ) {
      return List();
    }

    const ruleIds =
      this.props.inboxItem.groupedItems &&
      this.props.inboxItem.groupedItems
        .filter(item => item.context.type === 'trigger_notification')
        .map(item => item.context.ruleId);
    return ruleIds || List([this.props.inboxItem.context.ruleId]);
  }

  static getPropsFromStores(nextProps) {
    return {
      rules: TriggerRuleStore.getState().rules,
      sessionUser: AuthStore.getState().user.id,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    const ruleIds = this.getRuleIds();
    ruleIds.forEach(ruleId => TriggerRuleActions.fetchTriggerRule.defer(ruleId));
  }

  async toggleNotify(rule, active) {
    await TriggerRuleActions.updateTriggerRulePermissions(
      rule.id,
      List([
        new TriggerPermission({
          permission: 'NOTIFY',
          active: !active,
          userId: this.props.sessionUser,
        }),
      ])
    );

    this.loadData();
  }

  render() {
    const ruleIds = this.getRuleIds();
    const {rules} = this.props;
    const triggerRules = rules
      ? ruleIds.map(ruleId => rules.get(ruleId + '')).filter(rule => rule)
      : List();

    return (
      <MatchedRulePopover
        {...this.props}
        triggerRules={triggerRules}
        toggleNotify={this.toggleNotify}
      />
    );
  }
}
